"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyWorkspaceApp = createEmptyWorkspaceApp;
exports.isEmptyWorkspaceApp = isEmptyWorkspaceApp;
exports.createStartPageApp = createStartPageApp;
const app_base_contract_1 = require("./app-base-contract");
const EMPTY_ENTRY_TEXT = '<main></main>';
/** An empty internal App: one root route and one empty entry file. */
function createEmptyWorkspaceApp(appId, title) {
    const text = EMPTY_ENTRY_TEXT;
    return (0, app_base_contract_1.defineApp)({
        schemaVersion: app_base_contract_1.APP_DEFINITION_SCHEMA_VERSION,
        appId,
        title: title.trim(),
        rootRoutePath: '/',
        seo: {
            schemaVersion: 1,
            strategy: 'internalRoute',
            indexableByDefault: false,
            metadataSource: 'none',
            structuredDataTypes: [],
            canonical: 'disabled',
            hreflang: 'none',
            aiSearch: {
                llmsTxt: 'exclude',
                semanticSummary: 'none',
                robotsAiPolicy: 'noai',
            },
        },
        visibility: {},
        routes: [
            {
                route: {
                    path: '/',
                    title: title.trim(),
                    entry: 'index.html',
                    dataSourceKeys: [],
                    navigation: false,
                },
                filePaths: ['index.html'],
                interactionControlIds: [],
            },
        ],
        files: {
            'index.html': {
                path: 'index.html',
                contentType: 'text/html',
                text,
                bytes: new TextEncoder().encode(text).length,
                sha256: (0, app_base_contract_1.appBaseSha256Hex)(text),
            },
        },
    });
}
/** Whether an App still holds nothing but the empty entry file it starts with. */
function isEmptyWorkspaceApp(definition) {
    const files = Object.values(definition.files);
    return (files.length === 1 &&
        files[0]?.sha256 === (0, app_base_contract_1.appBaseSha256Hex)(EMPTY_ENTRY_TEXT));
}
/**
 * An App whose start page works on one table with the given page rights; the
 * App a plan describes before it exists.
 */
function createStartPageApp(input) {
    const start = createEmptyWorkspaceApp(input.appId, input.title);
    return (0, app_base_contract_1.defineApp)({
        ...start,
        resources: [{ sourceKey: input.sourceKey }],
        routes: start.routes.map(page => ({
            ...page,
            route: {
                ...page.route,
                dataSourceKeys: [input.sourceKey],
                access: input.access,
            },
        })),
    });
}
